import { useIsMobile } from "@/hooks/use-mobile";
import FilterBar from "@/components/FilterBar";
import MobileFilterBar from "@/components/MobileFilterBar";
import SearchBar from "@/components/SearchBar";
import { useCallback, useEffect, useState } from "react";

interface FiltersSectionProps {
  filters: any;
  availableOptions: any;
  onFilterChange: (key: string, values: string[]) => void;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  selectedEmiMonth?: string | null;
  onEmiMonthChange?: (month: string) => void;
  emiMonthOptions?: string[];
  loading?: boolean;
  searchLoading?: boolean;
  totalCount?: number;
}

const FiltersSection = ({
  filters,
  availableOptions,
  onFilterChange,
  searchTerm,
  onSearchChange,
  selectedEmiMonth,
  onEmiMonthChange,
  emiMonthOptions = [],
  loading = false,
  searchLoading = false,
  totalCount
}: FiltersSectionProps) => {
  const isMobile = useIsMobile();
  const [searchClearSignal, setSearchClearSignal] = useState(0);
  const [searchHasText, setSearchHasText] = useState(false);

  const handleSearchHasText = useCallback((hasText: boolean) => {
    setSearchHasText(hasText);
  }, []);

  const handleClearSearch = useCallback(() => {
    setSearchClearSignal((current) => current + 1);
  }, []);

  // Debug logging for filter options
  useEffect(() => {
    console.log('🔍 FiltersSection: Received availableOptions:', availableOptions);
    console.log('🔍 FiltersSection: Repayments options:', availableOptions?.repayments);
    console.log('🔍 FiltersSection: PTP Date options:', availableOptions?.ptpDateOptions);
    console.log('🔍 FiltersSection: Last Month Bounce options:', availableOptions?.lastMonthBounce);
  }, [availableOptions]);

  const searchBar = (
    <SearchBar
      value={searchTerm}
      onChange={onSearchChange}
      placeholder="Search by name, Applicant ID, or Vehicle RC Number..."
      loading={searchLoading}
      resultCount={searchTerm ? totalCount : undefined}
      inline={!isMobile}
      clearSignal={searchClearSignal}
      onHasTextChange={handleSearchHasText}
    />
  );

  return (
    <div className={isMobile ? "space-y-4" : undefined}>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200">
        {isMobile ? (
          <MobileFilterBar
            filters={filters}
            availableOptions={availableOptions}
            onFilterChange={onFilterChange}
            emiMonthOptions={emiMonthOptions}
            selectedEmiMonth={selectedEmiMonth}
            onEmiMonthChange={onEmiMonthChange}
            onClearSearch={handleClearSearch}
            hasSearchText={searchHasText}
          />
        ) : (
          <FilterBar
            filters={filters}
            availableOptions={availableOptions}
            onFilterChange={onFilterChange}
            selectedEmiMonth={selectedEmiMonth}
            onEmiMonthChange={onEmiMonthChange}
            emiMonthOptions={emiMonthOptions}
            toolbar={searchBar}
            onClearSearch={handleClearSearch}
            hasSearchText={searchHasText}
          />
        )}
      </div>

      {isMobile && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
          {searchBar}
        </div>
      )}
    </div>
  );
};

export default FiltersSection;
